let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jwzrB")).then(() => parcelRequire('gQlAC'));